import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CasesRoute } from '@modules/opportunities/presentation/routes';
import FilterButton from '@components/v2/FilterButton';
import { STATUS_GROUPS } from '../const';

const FilterButtons = () => {
  const { t } = useTranslation();

  const { status: currentStatusQuery } = CasesRoute.useSearch();
  const navigate = useNavigate({ from: CasesRoute.fullPath });

  const handleOnClick = (status: string[]) => {
    const statusesQuery = status && status.length > 0 ? status.join('|') : undefined;
    const isActive = statusesQuery === currentStatusQuery;

    navigate({
      search: (prev) => ({
        ...prev,
        page: 1,
        status: (!isActive ? statusesQuery : undefined),
      }),
    });
  };

  return (
    <>
      <FilterButton
        dataTest='draft-filter'
        handleClick={ () => handleOnClick([STATUS_GROUPS.DRAFT]) }
        isActive={ currentStatusQuery === STATUS_GROUPS.DRAFT }
      >
        {t('opportunity.caseList.v2.filterButtons.drafts')}
      </FilterButton>
      <FilterButton
        dataTest='active-cases-filter'
        handleClick={ () => handleOnClick([STATUS_GROUPS.ACTIVE]) }
        isActive={ currentStatusQuery === STATUS_GROUPS.ACTIVE }
      >
        {t('opportunity.caseList.v2.filterButtons.activeCases')}
      </FilterButton>
      <FilterButton
        dataTest='declined-filter'
        handleClick={ () => handleOnClick([STATUS_GROUPS.DECLINED]) }
        isActive={ currentStatusQuery === STATUS_GROUPS.DECLINED }
      >
        {t('opportunity.caseList.v2.filterButtons.declined')}
      </FilterButton>
    </>
  );
};

export default FilterButtons;
